

















import Vue from 'vue'
import Store from '@/services/Store'
import MainArea from '@/components/MainArea.vue'
import ImageArea from '@/components/ImageArea.vue'
import TextArea from '@/components/TextArea.vue'

export default Vue.extend({
  name: "QuizIntro",
  data(){
    return {
      quizImage: Store.quizState.getQuizImage(),
      introText: Store.quizState.getRandomIntro().text
    }
  },
  methods: {
    handleStartBtnClick(){
      this.$router.push({ name: 'QuizQuestion', params: { quiz: 'play' } })
    }
  },
  components: {
    MainArea, ImageArea, TextArea
  }
})
